import { BasketballPracticeOnSameDay } from '@hefe/models';
import { formatTime } from '@hefe/utils';
import { Divider, Space, Typography } from 'antd';
import CustomList from '../../../../core/components/custom-list/custom-list.component';
import { t } from '@hefe/i18n';

interface PracticeDetailsSameDayPracticesComponentProps {
  practices: BasketballPracticeOnSameDay[];
}

export default function PracticeDetailsSameDayPracticesComponent(
  props: PracticeDetailsSameDayPracticesComponentProps
) {
  return (
    <div>
      <Typography.Paragraph>
        {t('practices.other_practices.same_day.description')}
      </Typography.Paragraph>
      <CustomList
        className="practice-details-same-day-practices-list"
        itemLayout="horizontal"
        dataSource={props.practices}
        renderItem={(item: BasketballPracticeOnSameDay) => {
          const textDecoration = item?.canceled ? 'line-through' : 'none';
          return (
            <div style={{ textDecoration }}>
              <Space direction="vertical" size={2}>
                <Typography.Text strong style={{ textDecoration }}>
                  {item?.teams?.map((team) => team?.name).join(', ')}
                </Typography.Text>
                <Space>
                  <Typography.Text style={{ textDecoration }}>
                    {formatTime(item?.start)} - {formatTime(item?.end)}
                  </Typography.Text>
                  {item?.canceled && (
                    <Typography.Text>{t('canceled')}!</Typography.Text>
                  )}
                </Space>
              </Space>
              <Divider
                style={{
                  margin: 0,
                  padding: 0,
                  marginTop: 10,
                  marginBottom: 10,
                }}
              />
            </div>
          );
        }}
      />
    </div>
  );
}
